/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import { Avatar, IconButton } from '@material-ui/core';
import React from 'react';
import imagem from '../../utils/imagen';
import color from '../../constants/color';
import './index.css';
import { Input } from './styles';
import Trash from '../../assets/trash.png';
import icons from '../../constants/icons';
import warn from '../../constants/toast';

interface Props {
  style?: any;
  onChange?: any;
  onChangeFileName?: any;
  disabled?: boolean;
  id?: string;
  hasPhoto?: boolean;
  setHasPhoto: any;
  photo?: string;
  isError?: boolean;
}

const InputFileCommon: React.FC<Props> = ({
  onChange, onChangeFileName, disabled, id, hasPhoto, setHasPhoto, photo, isError,
}) => {
  const onFileChange = (event: any) => {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onloadend = async () => {
      if ((file?.size / 1024) > 200) {
        warn.wargingInfo('A imagem seleciona é muito grande, redimensione sua imagem para 200 KB!');
      } else {
        const newImage: any = await imagem.resizeImage(file);
        const imageBase64 = await imagem.convertImageBase64(newImage);

        onChange(imageBase64);
        onChangeFileName(file.name);
        setHasPhoto(true);
      }
    };
    reader.readAsDataURL(file);
  };
  return (
    <>
      {!hasPhoto ? (
        <div style={{
          display: 'flex', alignItems: 'center', width: '100%',
        }}
        >
          <input
            disabled={disabled}
            type="file"
            accept="image/png, image/jpeg"
            name="file"
            id={id || 'file'}
            onChange={onFileChange}
            className="inputfile"
          />
          <label
            style={{
              backgroundColor: 'white',
              alignItems: 'center',
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between',
              borderColor: isError ? 'red' : '#cecece',
              borderWidth: isError ? 1 : 1,
              borderStyle: 'dotted',
              borderRadius: 100,
            }}
            htmlFor="file"
          >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <img src={icons.libraryPhotoIcon} height={22} style={{ marginLeft: 6 }} width={22} alt="" />
              <div style={{
                color: isError ? 'red' : color.black, marginLeft: 14,
              }}
              >
                Foto
              </div>
            </div>
            <img src={icons.folderIcon} height={12} style={{ marginLeft: 6 }} width={12} alt="" />
          </label>
        </div>
      ) : (
        <Input style={{ marginTop: 2 }}>
          <Avatar src={photo || ''} />
          <IconButton onClick={() => setHasPhoto(false)}>
            <img src={Trash} alt="" height={16} width={14} />
          </IconButton>
        </Input>
      )}
    </>
  );
};

export default InputFileCommon;
